export default __webpack_public_path__ + "locales/en/UploadPanel.json?hash=78baef23b16832fca266f698a9fd24f3";